import React from 'react';
import './BalanceDisplay.css';

function BalanceDisplay({ balance, compact = false }) {
  if (!balance) {
    return (
      <div className="balance-display balance-empty">
        <span className="balance-empty-text">No allocation set</span>
      </div>
    );
  }

  const total = balance.allocation + balance.bonus_total;
  const usedPercent = total > 0 ? (balance.used.total / total) * 100 : 0;
  const pendingPercent = total > 0 ? (balance.pending.total / total) * 100 : 0;
  const availablePercent = Math.max(0, 100 - usedPercent - pendingPercent);

  if (compact) {
    return (
      <div className="balance-display balance-compact">
        <div className="balance-bar">
          <div className="balance-bar-used" style={{ width: `${usedPercent}%` }} />
          <div className="balance-bar-pending" style={{ width: `${pendingPercent}%` }} />
          <div className="balance-bar-available" style={{ width: `${availablePercent}%` }} />
        </div>
        <div className="balance-numbers-compact">
          <span>{balance.available.total} available</span>
          <span className="balance-total-compact">of {total}</span>
        </div>
      </div>
    );
  }

  return (
    <div className="balance-display">
      <div className="balance-bar">
        <div className="balance-bar-used" style={{ width: `${usedPercent}%` }} title={`Used: ${balance.used.total}`} />
        <div className="balance-bar-pending" style={{ width: `${pendingPercent}%` }} title={`Pending: ${balance.pending.total}`} />
        <div className="balance-bar-available" style={{ width: `${availablePercent}%` }} title={`Available: ${balance.available.total}`} />
      </div>
      <div className="balance-numbers">
        <div className="balance-item">
          <span className="balance-dot balance-dot-used" />
          <span className="balance-label">Used</span>
          <span className="balance-value">{balance.used.total}</span>
        </div>
        <div className="balance-item">
          <span className="balance-dot balance-dot-pending" />
          <span className="balance-label">Pending</span>
          <span className="balance-value">{balance.pending.total}</span>
        </div>
        <div className="balance-item">
          <span className="balance-dot balance-dot-available" />
          <span className="balance-label">Available</span>
          <span className="balance-value balance-value-primary">{balance.available.total}</span>
        </div>
      </div>
      {balance.bonus_total > 0 && (
        <div className="balance-bonus-note">
          Includes {balance.bonus_total} bonus day{balance.bonus_total !== 1 ? 's' : ''}
          {balance.available.bonus > 0 && ` (${balance.available.bonus} remaining)`}
        </div>
      )}
    </div>
  );
}

export default BalanceDisplay;
